import React from "react";
import layout1 from "./assets/gdn/1.svg";
import layout2 from "./assets/gdn/2.svg";
import layout3 from "./assets/gdn/3.svg";

const ICONS: Record<number, string> = {
  1: layout1,
  2: layout2,
  3: layout3,
};

export const hasGdnLayoutIcon = (id: number): boolean => id in ICONS;

const GdnLayoutIcon = ({id}: {id: number}) => {
  const src = ICONS[id];
  if (!src) return null;

  return <img className="gdn-layout-icon" src={src} alt="" aria-hidden="true" />;
};

export default GdnLayoutIcon;
